export const planConfig = [
    {
        packageId: 5,
        packageName: "Smart Institute Management",
        subtitle: "Simplify, Organize, Grow",
        PackageDurationInDays: 365,
        featured: false,
        features: [
            "Course Management",
            "Enquiry-to-Admission",
            "Flexible Batch Scheduling",
            "Attendance Monitoring",
            "Flexible Fees Management"
        ],
    },
    {
        packageId: 6,
        packageName: "Next-Gen Test Management",
        subtitle: "Engage, Assess, Excel",
        PackageDurationInDays: 365,
        featured: false,
        features: [
            "Build Unlimited Question Banks & Tests",
            "Scale for Unlimited Students",
            "Powerful Test Analytics & Insights",
            "Supports JEE, CET & NEET Exam Patterns",
            "Support competitive exam format",
            "Effortlessly Assign & Schedule Tests",
            "Separate Mobile Apps for Admins & Students",
        ],
    },
    {
        packageId: 7,
        packageName: "All-in-One Education Suite",
        subtitle: "Manage & Assess Seamlessly",
        PackageDurationInDays: 365,
        featured: true,
        features: [
            "Course Management",
            "Enquiry-to-Admission",
            "Flexible Batch Scheduling",
            "Attendance Monitoring",
            "Build Unlimited Question Banks & Tests",
            "Scale for Unlimited Students",
            "Powerful Test Analytics & Insights",
            "Supports JEE, CET & NEET Exam Patterns",
            "Support competitive exam format",
            "Separate Mobile Apps for Admins & Students"
        ],
    },
];
